import React, {Component} from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS} from "immutable";
import Form, {splitTags, tagsToString} from "./OrderTagsForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {ORDER_TAGS} from "../../queries/shipping";
import {cancelSetOrderTags} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class SetOrderTagsFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      tags: splitTags(values.get("tags", ""))
    }
    return this.props.setShippingOrderTags(updatedValues)
      .then((response) => {
        if (response.data.setShippingOrderTags.errors.length <= 0) {
          this.handleCancel();
        } else {
          let errors = createValidationErrors(response.data.setShippingOrderTags.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelSetOrderTags();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let initialValues = fromJS({
      tags: tagsToString(data.shippingOrder && data.shippingOrder.tags)
    })
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const SET_ORDER_TAGS = gql`
  mutation setShippingOrderTags($data: SetShippingOrderTagsInput!) {
    setShippingOrderTags(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(ORDER_TAGS, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        orderId: props.orderId
      }
    })
  }),
  graphql(SET_ORDER_TAGS, {
    props: ({ mutate }) => ({
      setShippingOrderTags: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelSetOrderTags})(withQuery(SetOrderTagsFormContainer));
